const SECRET_KEY_BASE64 = "VSZKsJvYFlufUGRcg8szIVBJ3tLf0eh1V2Xq4LuWy5U="; // same as server key

// console.log(btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))))
async function getKey() {
  const keyBytes = Uint8Array.from(atob(SECRET_KEY_BASE64), c => c.charCodeAt(0));
  return await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-CBC" },
    false,
    ["encrypt", "decrypt"]
  );
}

export async function encryptData(data) {
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const cryptoKey = await getKey();
  const encodedData = new TextEncoder().encode(JSON.stringify(data));
  console.log("encodedData", encodedData)
  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    cryptoKey,
    encodedData
  );

  return {
    encryptedData: btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer))),
    iv: btoa(String.fromCharCode(...iv))
  };
}

export async function decryptData(encryptedData, ivBase64) {
  const cryptoKey = await getKey();
  const encryptedBytes = Uint8Array.from(atob(encryptedData), c => c.charCodeAt(0));
  const iv = Uint8Array.from(atob(ivBase64), c => c.charCodeAt(0));

  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    cryptoKey,
    encryptedBytes
  );

  const decoded = new TextDecoder().decode(decryptedBuffer);
  return JSON.parse(decoded);
}
